import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Icon, TooltipComponent } from "../../../components/Component";
import {
  Button,
  Card,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import FormSelect from "../../form-components/SelectComponent";
import { Badge, Drawer, Popconfirm, Progress, Table, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import SearchInput from "../../form-components/SearchComponent";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SkeletonTable, {
  SkeletonTableColumnsType,
} from "../../../utils/skeleton-templates/table";
import { projectsApis } from "../../../api/projects";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import { getDirtyFieldsOnly } from "../../../utils/use-form/GetDirtyFieldsOnly";
import { updateAllProjectsListViewTableColumnsConfig } from "../../../store/slices/projectManagement/all-projects/allProjectsListViewTableColumnsConfig";
import { RootState } from "../../../store/store";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { updateMenuData } from "../../../store/slices/misc/menuData";
import TopMenu from "../../../route/topMenu";

function PendingProjectsListView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: SideNavCollapse } = useSelector(
    (state: any) => state.SideNavCollapseStatus
  );
  const { data: columnsConfigData } = useSelector(
    (state: any) => state.PendingProjectsListViewTableColumnsConfig
  );
  const { data: RootPageRenderState } = useSelector(
    (state: RootState) => state.RootPageRenderState
  );
  const dispatch = useDispatch();
  const [tableConfigModal, setTableConfigModal] = useState(false);
  const [filtersModal, setFiltersModal] = useState(false);
  const [filteredData, setFilteredData] = useState<any>();
  const columns: any = [
    {
      title: "Project Name",
      dataIndex: "projectTitle",
      key: "projectTitle",
      width: 280,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`draftStatus-${record?.projectId}`}
              onClick={() => {
                // dispatch(
                //   updateProjectInDetailModalSlice({
                //     id: record?.projectId,
                //     open: true,
                //     derivedProjectStatus: record?.derivedProjectStatus,
                //     projectName: record?.projectTitle,
                //     extra: {
                //       screenName: "Pending Approval",
                //       plannedStartDate: record?.plannedStartDate,
                //       plannedEndDate: record?.plannedEndDate,
                //     },
                //   })
                // );
                navigate("/pms/project/view", {
                  state: {
                    id: record?.projectId,
                    derivedProjectStatus: record?.derivedProjectStatus,
                    projectName: record?.projectTitle,
                    extra: {
                      screenName: "Pending Approval",
                      plannedStartDate: record?.plannedStartDate,
                      plannedEndDate: record?.plannedEndDate,
                    },
                  },
                });
                // dispatch(
                //   updatePhaseInDetailModalSlice({
                //     isUpdated: true,
                //   })
                // )
              }}
            >
              {text}
            </span>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "derivedProjectStatus",
      key: "derivedProjectStatus",
      width: 200,
    },
    {
      title: "Phases",
      dataIndex: "phases",
      key: "phases",
      width: 200,
      render: (text: any, record: any) => {
        return (
          <Tooltip
            title={`Closed: ${record.completedPhases}, Open: ${record.totalPhases}`}
            placement="top"
          >
            <Progress
              strokeLinecap="butt"
              size={[186, 10]}
              percent={record.phasesCompletionPercentage}
              status="active"
              strokeColor={{
                from: "#87d068",
                to: "#87d068",
              }}
            />
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Activity",
    //   dataIndex: "activity",
    //   key: "activity",
    //   width: 200,
    //   render: (text: any, record: any) => {
    //     return (
    //       <Tooltip
    //         title={`Closed: ${record.completedActivities}, Open: ${record.totalActivities}`}
    //         placement="top"
    //       >
    //         <Progress
    //           strokeLinecap="butt"
    //           size={[186, 10]}
    //           percent={record.activityCompletionPercentage}
    //           status="active"
    //           strokeColor={{
    //             from: "#87d068",
    //             to: "#87d068",
    //           }}
    //         />
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   title: "Tasks",
    //   dataIndex: "tasks",
    //   key: "tasks",
    //   width: 200,
    //   render: (text: any, record: any) => {
    //     return (
    //       <Tooltip
    //         title={`Closed: ${record?.completedTasks}, Open: ${record?.totalTasks}`}
    //         placement="top"
    //       >
    //         <Progress
    //           strokeLinecap="butt"
    //           size={[186, 10]}
    //           percent={record?.tasksCompletionPercentage}
    //           status="active"
    //           strokeColor={{
    //             from: "#87d068",
    //             to: "#87d068",
    //           }}
    //         />
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: "Issues",
      dataIndex: "issues",
      key: "issues",
      width: 200,
      render: (data: any) => {
        const { closed, open, percent } = data || {};
        return (
          <Tooltip title={`Closed: ${closed}, Open: ${open}`} placement="top">
            <Progress
              strokeLinecap="butt"
              size={[186, 10]}
              percent={percent}
              status="active"
              strokeColor={{
                from: "#ff4d4f",
                to: "#faad14",
              }}
            />
          </Tooltip>
        );
      },
    },
    {
      title: "Planned Start Date",
      dataIndex: "plannedStartDate",
      key: "plannedStartDate",
      width: 200,
      render: (text: any) => {
        return dayjs(text).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Planned End Date",
      dataIndex: "plannedEndDate",
      key: "plannedEndDate",
      width: 200,
      render: (text: any) => {
        return dayjs(text).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Group",
      dataIndex: "projectGroupName",
      key: "group",
      width: 200,
    },
    {
      title: "Created By",
      dataIndex: "createdByUserName",
      key: "createdByUserName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`createdBy-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 22)}... ` : text}
            </span>
            {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`createdBy-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (text: any) => {
        return text && dayjs(text).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Owner",
      dataIndex: "projectOwnerName",
      key: "resourceHeads",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`ownerName-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 22)}... ` : text}
            </span>
            {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`ownerName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 250,
    },
    {
      title: "Budget",
      dataIndex: "budgetName",
      key: "budgetName",
      width: 250,
    },
    // {
    //   title: "Resource Heads",
    //   dataIndex: "resourceHeads",
    //   key: "resourceHeads",
    //   width: 200,
    // },
    // {
    //   title: "Material BOQ",
    //   dataIndex: "materials",
    //   key: "materials",
    //   width: 200,
    // },
    // {
    //   title: "Tags",
    //   dataIndex: "tags",
    //   key: "tags",
    //   width: 200,
    // },
    // {
    //   title: "Calendar",
    //   dataIndex: "calendarTitle",
    //   key: "calendarTitle",
    //   width: 280,
    // },
    // {
    //   title: "RateCard Title",
    //   dataIndex: "rateCardTitle",
    //   key: "rateCardTitle",
    //   width: 280,
    // },
  ];
  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, dirtyFields },
  } = methods;
  const tableMethods = useForm();
  const [openSitePopUp, setOpenSitePopUp] = useState<string | null>(null);
  const [customDateRange, setCustomDateRange] = useState<any>();
  const [dataSource, setDataSource] = useState<any>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50"],

    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [searchQuery, setsearchQuery] = useState(null);
  const [selectFilter1, setselectFilter1] = useState(null);
  const [selectFilter2, setselectFilter2] = useState(null);
  const [selectFilter3, setselectFilter3] = useState(null);
  const [dateRange, setdateRange] = useState("Quarter to Date");
  const [filterCount, setFilterCount] = useState(0);
  const [cardViewCurrentPage, setCardViewCurrentPage] = useState(0);
  const [endOfList, setEndOfList] = useState(false);

  const [tagFiltersList, setTagFiltersList] = useState([]);
  const [ownerFiltersList, setOwnersFiltersList] = useState([]);
  const [groupFiltersList, setGroupsFiltersList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchData = async (params: any, append = false) => {
    setLoading(true);
    try {
      const {
        current,
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        searchQuery,
      } = params;
      const apiResponse = await projectsApis.getProjectPendingApprovalsList({
        page: current,
        pageSize: pageSize,
        searchQuery,
        direction,
        sortOrder,
        pageDiff,
        paginationId,
        projectStatus: "Pending Approval",
      });
      const { data, status } = apiResponse;
      if (status) {
        const { list, count } = data;
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));

        setDataSource((prev: any) => (append ? [...prev, ...list] : list));
      }
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const tableOnChange = async (
    newPagination: any,
    filters: any,
    sorter: any
  ) => {
    const apiParams = {
      oldPage: pagination.current,
      current: newPagination.current?.toString(),
      sortOrder: "DESC",
      pageSize: pagination.pageSize,
      direction: "P",
      pageDiff: 0,
      paginationId: null,
      searchQuery,
    };

    if (sorter.order) {
      apiParams.sortOrder = sorter.order === "ascend" ? "ASC" : "DESC";
    } else if (newPagination.pageSize != pagination.pageSize) {
      // if page size is changed
      apiParams.pageSize = newPagination.pageSize;
      const _currentPage =
        Math.floor(
          ((Number(pagination.current) - 1) * Number(pagination.pageSize)) /
            Number(newPagination.pageSize)
        ) + 1; // calculating new current page based on new page size
      apiParams.current = _currentPage;
      apiParams.pageDiff = _currentPage - 1;
    } else {
      if (newPagination.current != pagination.current) {
        apiParams.direction =
          newPagination.current > pagination.current
            ? "F" // Forward
            : "B"; // Backward
        apiParams.paginationId =
          apiParams.direction == "F"
            ? dataSource[dataSource.length - 1]?.paginationId // Last item ID for backward direction
            : dataSource[0]?.paginationId; // First item ID for forward direction

        apiParams.pageDiff =
          Math.abs(newPagination.current - pagination.current) - 1;
      }
    }

    setPagination({
      ...pagination,
      current: apiParams.current,
      pageSize: apiParams.pageSize,
    });
    await fetchData({
      ...apiParams,
      selectFilter1,
      selectFilter2,
      selectFilter3,
    });
  };

  const refreshListView = () => {
    try {
      setEndOfList(false);
      setPagination({
        current: 1,
        pageSize: 10,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        total: 0,
      });
      refreshData({
        pageDiff: 0,
      }); // calling for initial data load , if the view type is table
    } catch (error) {}
  };

  useEffect(() => {
    refreshListView();
    dispatch(updateMenuData(TopMenu?.activeProjects));
  }, []);

  // If navigated here from a notification (location.state contains id/notificationData),
  useEffect(() => {
    try {
      const st: any = (location as any)?.state;
      if (st && (st.id || st.projectId)) {
        const pid = st.id || st.projectId;
        if (st.derivedProjectStatus || st.notificationData) {
          navigate("/pms/project/view", {
            state: {
              id: pid,
              projectId: pid,
              projectName: st.projectName,
              derivedProjectStatus: st.derivedProjectStatus,
              extra: st.extra || { screenName: "Pending Approval" },
              notificationData: st.notificationData,
            },
          });
        }
      }
    } catch (err) {
      console.error("Error handling pending-approvals redirect:", err);
    }
  }, [location, navigate]);

  useEffect(() => {
    if (filteredData && Object?.keys(filteredData).length > 0) {
      refreshListView();
    }
  }, [filteredData]);

  const refreshData = (overRideData?: any) => {
    fetchData({
      oldPage: 1,
      current: pagination.current.toString(),
      sortOrder: "DESC",
      pageSize: pagination.pageSize.toString(),
      direction: "P",
      pageDiff: pagination.current - 1,
      paginationId: null,
      searchQuery,
      dateRange: "Quarter to Date",
      // customDateRange,
      ...overRideData,
    });
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  const fetchTagFiltersData = async () => {
    try {
      const apiResponse = await projectsApis.getTagsFilterData(
        "Pending Approval"
      );
      const { data, status } = apiResponse;
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item.tagName,
            value: item.tagId,
          };
        });
        setTagFiltersList(options);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  const fetchOwnersFiltersData = async () => {
    try {
      const apiResponse = await projectsApis.getOwnersFilterData(
        "Pending Approval"
      );
      const { data, status } = apiResponse;
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item.userName,
            value: item.userId,
          };
        });
        setOwnersFiltersList(options);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  const fetchGropusFiltersData = async () => {
    try {
      const apiResponse = await projectsApis.getGroupsFilterData(
        "Pending Approval"
      );
      const { data, status } = apiResponse;
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item.projectGroupName,
            value: item.projectGroupId,
          };
        });
        setGroupsFiltersList(options);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    if (filtersModal) {
      callFiltersApi();
    }
  }, [filtersModal]);

  const callFiltersApi = () => {
    fetchTagFiltersData();
    fetchOwnersFiltersData();
    fetchGropusFiltersData();
  };

  const configTableColumns = (columns: any, columnsConfigData: any) => {
    return columns.map((column: any) => {
      return {
        ...column,
        hidden: columnsConfigData?.[column.key] === false,
      };
    });
  };
  return (
    <>
      <Head title={"Pending Approvals"} />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className="card-inner card-inner-lg"
              style={{ minHeight: "87vh" }}
            >
              <FormProvider {...methods}>
                <form>
                  <div
                    className="nk-ibx-head p-0 m-0 mt-1 w-100 d-flex justify-content-between align-items-center"
                    style={{ minHeight: "40px", border: "0px" }}
                  >
                    <div className="nk-ibx-head-actions w-45 ms-1">
                      <ul className="nk-ibx-head-tools g-1 m-0 p-0 w-100 ">
                        <div className={`w-100 m-0 `}>
                          <SearchInput
                            name="search"
                            placeholder="Search..."
                            width="100%"
                            prefixIcon={<SearchOutlined />}
                            onDebouncedSearch={async (value: any) => {
                              setsearchQuery(value);
                              setPagination({
                                ...pagination,
                                current: 1,
                              });
                              await fetchData({
                                oldPage: 1,
                                current: 1,
                                sortOrder: "DESC",
                                pageSize: pagination.pageSize.toString(),
                                direction: "P",
                                pageDiff: 0,
                                paginationId: null,
                                searchQuery: value,
                                selectFilter1,
                                selectFilter2,
                                selectFilter3,
                                // dateRange,
                                // customDateRange,
                              });
                            }}
                            debounceDelay={300} // Adjust delay as needed
                          />
                        </div>
                      </ul>
                    </div>
                    <ul className="nk-ibx-head-tools g-1 m-0 p-0 ">
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            className="dropdown-toggle btn btn-icon btn-trigger"
                            onClick={(ev) => {
                              refreshListView();
                            }}
                          >
                            <Icon name="redo"></Icon>
                          </DropdownToggle>
                        </UncontrolledDropdown>
                      </li>

                      <li className="me-n1">
                        <a
                          href="#filter"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setFiltersModal(true);
                          }}
                          className={`btn-icon me-2`}
                        >
                          <Badge
                            color="geekblue"
                            size="small"
                            count={filterCount}
                          >
                            <Icon
                              style={{ fontSize: "20px" }}
                              name="filter"
                            ></Icon>
                          </Badge>
                        </a>
                      </li>
                      <li className="d-none d-sm-block">
                        <UncontrolledDropdown>
                          <Popconfirm
                            title={<></>}
                            icon={<></>}
                            placement="leftTop"
                            showCancel={false}
                            open={tableConfigModal}
                            okButtonProps={{
                              style: {
                                display: "none",
                              },
                            }}
                            onOpenChange={(visible) => {
                              setTableConfigModal(visible);
                            }}
                            description={
                              <div className="">
                                <div className="form-label">
                                  Toggle Columns View
                                </div>
                                <div className="d-flex flex-wrap m-0">
                                  <ul className="link-list-opt no-bdr">
                                    {Object.keys(columnsConfigData)
                                      ?.filter(
                                        (_key) =>
                                          columns?.find(
                                            (col: any) => col.key == _key
                                          )?.title
                                      )
                                      ?.map((_key) => {
                                        return (
                                          <li
                                            style={{ width: "190px" }}
                                            className={
                                              columnsConfigData[_key]
                                                ? "active"
                                                : ""
                                            }
                                          >
                                            <DropdownItem
                                              tag="a"
                                              href="#tableView"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                console.log(
                                                  _key,
                                                  " ",
                                                  columnsConfigData[_key]
                                                );

                                                dispatch(
                                                  updateAllProjectsListViewTableColumnsConfig(
                                                    {
                                                      [_key]:
                                                        !columnsConfigData[
                                                          _key
                                                        ],
                                                    }
                                                  )
                                                );
                                              }}
                                            >
                                              <span>
                                                {
                                                  columns?.find(
                                                    (col: any) =>
                                                      col.key == _key
                                                  )?.title
                                                }
                                              </span>
                                            </DropdownItem>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            }
                          >
                            <DropdownToggle
                              tag="a"
                              className="dropdown-toggle btn btn-icon btn-trigger"
                            >
                              <Icon name="setting-alt"></Icon>
                            </DropdownToggle>
                          </Popconfirm>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </div>
                </form>
              </FormProvider>

              <div className="card-inner card-inner-lg p-0">
                <div className="content clearfix">
                  <div
                    style={{
                      width: screenSize - (SideNavCollapse ? 120 : 320) + "px",
                      margin: "10px auto",
                    }}
                  >
                    <SkeletonTable
                      loading={loading}
                      columns={columns as SkeletonTableColumnsType[]}
                    >
                      <Table
                        rowKey="uid"
                        columns={configTableColumns(columns, columnsConfigData)}
                        dataSource={dataSource}
                        pagination={pagination}
                        onChange={tableOnChange}
                        bordered
                        size="middle"
                        scroll={{
                          x: 1100,
                        }}
                      />
                    </SkeletonTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Content>

      <Drawer
        maskClosable={false}
        title={
          <div className="d-flex justify-content-between align-items-center">
            <strong>Filters</strong>
            <>
              <div style={{ textAlign: "right" }}>
                <Button
                  onClick={() => {
                    methods.reset();
                    setFilterCount(0);
                  }}
                  color=""
                  className="m-3 mt-0 mb-0 ps-4 pe-4"
                  size="sm"
                >
                  <span style={{ color: "#0772f8" }}>Reset</span>
                </Button>
              </div>
            </>
          </div>
        }
        placement="right"
        width={450}
        onClose={() => {
          setFiltersModal(false);
        }}
        open={filtersModal}
        styles={{ body: { paddingBottom: 80 } }}
      >
        <div className="d-flex align-items-center flex-wrap w-100">
          <FormProvider {...methods}>
            <form
              onSubmit={methods.handleSubmit((data) => {
                setFilteredData(data);
                setFiltersModal(false);
                setFilterCount(0);
                // Count how many fields were actually changed (dirty)
                const dirtyData = getDirtyFieldsOnly(data, dirtyFields);
                console.log("dirty", dirtyData);
                const count =
                  dirtyData !== undefined && Object.keys(dirtyData).length;

                setFilterCount(count || 0);
              })}
              className="w-100"
            >
              <div key={"filters"} className="mb-2 mt-0">
                <FormMultiSelect
                  name={`group`}
                  label={"Group"}
                  placeholder={"filter By Group"}
                  options={groupFiltersList}
                />
              </div>
              <div key={"filters2"} className="mb-2 mt-0">
                <FormMultiSelect
                  name={`owner`}
                  label={"Owner"}
                  placeholder={"By Owner"}
                  options={ownerFiltersList}
                />
              </div>
              <div key={"filters3"} className="mt-0 mb-2">
                <FormSelect
                  name={`completion`}
                  label={"Completion %"}
                  placeholder={"By Completion %"}
                  options={Array.from({ length: 20 }, (_, i) => {
                    const start = i * 5 + 1;
                    const end = (i + 1) * 5;
                    return {
                      value: `${start}-${end}`,
                      label: `${start}–${end}%`,
                    };
                  })}
                />
              </div>
              <div key={"filters4"} className="mt-0 mb-2">
                <FormMultiSelect
                  name={`tag`}
                  label={"Tag"}
                  placeholder={"By Tag"}
                  options={tagFiltersList}
                />
              </div>

              <div key={"filters6"} className="mt-0 mb-2">
                <FormMultiSelect
                  name={`status`}
                  label={"Status"}
                  placeholder={"By Status"}
                  options={[
                    {
                      value: 1,
                      label: "Pending",
                    },
                    {
                      value: 2,
                      label: "In Progress",
                    },
                    {
                      value: 3,
                      label: "Completed",
                    },
                  ]}
                />
              </div>

              <div className="actions clearfix">
                <ul>
                  <li>
                    <Button color="primary" size="sm" type="submit">
                      Find
                    </Button>
                  </li>
                  <li>
                    <Button
                      size="sm"
                      color="primary"
                      className="btn-dim btn btn-secondary"
                      type="button"
                      onClick={() => {
                        methods.reset();
                        setFiltersModal(false);
                        setFilterCount(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </li>
                </ul>
              </div>
            </form>
          </FormProvider>
        </div>
      </Drawer>
    </>
  );
}

export default PendingProjectsListView;
